export type FilterMode = 'all' | 'open' | 'emergency' | 'nonstop'

const FILTER_QUERY_KEYS: FilterMode[] = ['emergency', 'nonstop', 'open']

export function useClinicFilter() {
  const route = useRoute()
  const router = useRouter()

  const activeFilter = computed<FilterMode>(() => {
    if (route.query.emergency === 'true') return 'emergency'
    if (route.query.nonstop === 'true') return 'nonstop'
    if (route.query.open === 'true') return 'open'
    return 'all'
  })

  function setFilter(mode: FilterMode) {
    const newMode = activeFilter.value === mode ? 'all' : mode

    const query: Record<string, string | undefined> = {
      ...route.query,
      page: undefined,
    }

    for (const key of FILTER_QUERY_KEYS) {
      query[key] = undefined
    }

    if (newMode !== 'all') {
      query[newMode] = 'true'
    }

    router.push({ query })
  }

  return {
    activeFilter,
    setFilter,
  }
}
